import { VehicleConfiguration } from 'core/models/vehicleConfiguration';
import { VehicleController } from 'core/repositories/VehicleController';
import { createListenerManager } from 'infrastructure/utility/ListenerManager';

export class AdjustedVehicleController implements VehicleController {
    private readonly listenerManager = createListenerManager<VehicleController.EventListener>(listeners => {
        const listener = (event: VehicleController.Event) => {
            switch (event.eventType) {
                case 'accel':
                    {
                        const adjusted = {
                            ...event,
                            accel: Math.min(event.accel * (this.config?.accelScale ?? 1.0), this.config?.accelCap ?? 1.0),
                        };
                        listeners.forEach(listener => listener(adjusted));
                    }
                    break;
                default:
                    listeners.forEach(listener => listener(event));
                    break;
            }
        };

        this.controller.addEventListener(listener);

        return () => {
            this.controller.removeEventListener(listener);
        };
    });

    constructor(private config: VehicleConfiguration | undefined, private controller: VehicleController) {
    }

    addEventListener(listener: VehicleController.EventListener): void {
        this.listenerManager.addListener(listener);
    }

    removeEventListener(listener: VehicleController.EventListener): void {
        this.listenerManager.removeListener(listener);
    }

    pushEvent(event: VehicleController.Event): void {
        this.controller.pushEvent(event);
    }
}
